import { render, staticRenderFns } from "./deleveryList.vue?vue&type=template&id=6b9bc1d9&"
import script from "./deleveryList.vue?vue&type=script&lang=js&"
export * from "./deleveryList.vue?vue&type=script&lang=js&"
import style0 from "./deleveryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports